// Auto-generated from TSV/JSON files. Do not edit manually.
export type KnownRangeSource = { label: string; start: string; end: string };

export const BOOKMARKLET_CODE =
  '(async()=>{const e=e=>new Promise((t=>setTimeout(t,e)));document.head.innerHTML="",document.body.innerHTML="<pre>Downloaded 0 games\u2026</pre>";const t=document.querySelector("pre"),n=[];let o=0,r=0;for(;;){const a=`/profile/history?skip=${o}`,i=await fetch(a,{credentials:"include"});if(!i.ok)return void(t.textContent=`Failed at skip=${o} (${i.status})`);let s;const d=await i.text();try{s=JSON.parse(d)}catch(e){return t.textContent="Invalid JSON response. Check console.",void console.error(e)}if(!Array.isArray(s)||0===s.length)break;n.push(...s),r+=s.length,t.textContent=`Downloaded ${r} games\u2026`,o+=s.length,await e(1500)}if(!n.length)return void(t.textContent="No games were downloaded.");const a=new Blob([JSON.stringify(n,null,2)],{type:"application/json"}),i=URL.createObjectURL(a),s=document.createElement("a");s.href=i,s.download="game_history.json",document.body.appendChild(s),s.click(),s.remove(),URL.revokeObjectURL(i),t.textContent=`Finished. Saved ${n.length} games.`})();' as const;

export const IDENTITY_TO_FACTION: Record<string, string> = Object.freeze({
  "419: Amoral Scammer": "criminal",
  "A Teia: IP Recovery": "jinteki",
  "AU Co.: The Gold Standard in Clones": "jinteki",
  "Acme Consulting: The Truth You Need": "nbn",
  "Adam: Compulsive Hacker": "adam",
  "AgInfusion: New Miracles for a New World": "jinteki",
  "Akiko Nisei: Head Case": "shaper",
  "Alice Merchant: Clan Agitator": "anarch",
  "Amp\u00e8re: Cybernetics For Anyone": "neutral_corp",
  "Andromeda: Dispossessed Ristie": "criminal",
  "Apex: Invasive Predator": "apex",
  "Argus Security: Protection Guaranteed": "weyland_consortium",
  "Arissana Rocha Nahu: Street Artist": "shaper",
  'Armand "Geist" Walker: Tech Lord': "criminal",
  "Asa Group: Security Through Vigilance": "haas_bioroid",
  'Ayla "Bios" Rahim: Simulant Specialist': "shaper",
  "Az McCaffrey: Mechanical Prodigy": "criminal",
  "Azmari EdTech: Shaping the Future": "nbn",
  "BANGUN: When Disaster Strikes": "weyland_consortium",
  'Barry "Baz" Wong: Tri-Maf Veteran': "criminal",
  "Blue Sun: Powering the Future": "weyland_consortium",
  'Boris "Syfr" Kovac: Crafty Veteran': "criminal",
  "Captain Padma Isbister: Intrepid Explorer": "shaper",
  "Cerebral Imaging: Infinite Frontiers": "haas_bioroid",
  "Chaos Theory: W\u00fcnderkind": "shaper",
  "Chronos Protocol: Haas-Bioroid": "UNKNOWN",
  "Chronos Protocol: Selective Mind-mapping": "jinteki",
  "Cybernetics Division: Humanity Upgraded": "haas_bioroid",
  "Dewi Subrotoputri: Pedagogical Dhalang": "shaper",
  "Earth Station: SEA Headquarters": "weyland_consortium",
  "Edward Kim: Humanity's Hammer": "anarch",
  'Ele "Smoke" Scovak: Cynosure of the Net': "shaper",
  "Epiphany Analytica: Nations Undivided": "nbn",
  "Es\u00e2 Afontov: Eco-Insurrectionist": "anarch",
  "Exile: Streethawk": "shaper",
  "Freedom Khumalo: Crypto-Anarchist": "anarch",
  "Fringe Applications: Tomorrow, Today": "weyland_consortium",
  "GRNDL: Power Unleashed": "weyland_consortium",
  "Gabriel Santiago: Consummate Professional": "criminal",
  "Gagarin Deep Space: Expanding the Horizon": "weyland_consortium",
  "GameNET: Where Dreams are Real": "nbn",
  "Haarpsichord Studios: Entertainment Unleashed": "nbn",
  "Haas-Bioroid: Architects of Tomorrow": "haas_bioroid",
  "Haas-Bioroid: Engineering the Future": "haas_bioroid",
  "Haas-Bioroid: Precision Design": "haas_bioroid",
  "Haas-Bioroid: Stronger Together": "haas_bioroid",
  "Harishchandra Ent.: Where You're the Star": "nbn",
  "Harmony Medtech: Biomedical Pioneer": "jinteki",
  "Hayley Kaplan: Universal Scholar": "shaper",
  "Hoshiko Shiro: Untold Protagonist": "anarch",
  "Hyoubu Institute: Absolute Clarity": "jinteki",
  "Iain Stirling: Retired Spook": "criminal",
  "Industrial Genomics: Growing Solutions": "jinteki",
  "Information Dynamics: All You Need To Know": "nbn",
  "Issuaq Adaptics: Sustaining Diversity": "jinteki",
  'Jamie "Bzzz" Micken: Techno Savant': "shaper",
  "Jemison Astronautics: Sacrifice. Audacity. Success.": "weyland_consortium",
  "Jesminder Sareen: Girl Behind the Curtain": "shaper",
  "Jinteki Biotech: Life Imagined": "jinteki",
  "Jinteki: Personal Evolution": "jinteki",
  "Jinteki: Potential Unleashed": "jinteki",
  "Jinteki: Replicating Perfection": "jinteki",
  "Jinteki: Restoring Humanity": "jinteki",
  "Kabonesa Wu: Netspace Thrillseeker": "shaper",
  'Kate "Mac" McCaffrey: Digital Tinker': "shaper",
  'Ken "Express" Tenma: Disappeared Clone': "criminal",
  "Khan: Savvy Skiptracer": "criminal",
  "LEO Construction: Labor Solutions": "haas_bioroid",
  "Laramy Fisk: Savvy Investor": "criminal",
  "Lat: Ethical Freelancer": "shaper",
  "Leela Patel: Trained Pragmatist": "criminal",
  "Liza Talking Thunder: Prominent Legislator": "criminal",
  "Los: Data Hijacker": "criminal",
  "Magdalene Keino-Chemutai: Cryptarchitect": "shaper",
  "MaxX: Maximum Punk Rock": "anarch",
  "Mercury: Chrome Libertador": "criminal",
  "MirrorMorph: Endless Iteration": "haas_bioroid",
  "Mti Mwekundu: Life Improved": "jinteki",
  "MuslihaT: Multifarious Marketeer": "criminal",
  "NBN: Controlling the Message": "nbn",
  "NBN: Making News": "nbn",
  "NBN: Reality Plus": "nbn",
  "NBN: The World is Yours*": "nbn",
  "NEXT Design: Guarding the Net": "haas_bioroid",
  "Nasir Meidan: Cyber Explorer": "shaper",
  'Nathaniel "Gnat" Hall: One-of-a-Kind': "anarch",
  "Near-Earth Hub: Broadcast Center": "nbn",
  "Nebula Talent Management: Making Stars": "nbn",
  "Nero Severn: Information Broker": "criminal",
  "New Angeles Sol: Your News": "nbn",
  "Nisei Division: The Next Generation": "jinteki",
  "Noise: Hacker Extraordinaire": "anarch",
  "Nova Initiumia: Catalyst & Impetus": "neutral_runner",
  "Null: Whistleblower": "anarch",
  "Nuvem SA: Law of the Land": "weyland_consortium",
  'Nyusha "Sable" Sintashta: Symphonic Prodigy': "criminal",
  "Ob Superheavy Logistics: Extract. Export. Excel.": "weyland_consortium",
  "Omar Keung: Conspiracy Theorist": "anarch",
  "PT Untaian: Life's Building Blocks": "jinteki",
  "Po\u00e9tr\u00ef Luxury Brands: All the Rage": "haas_bioroid",
  "Pravdivost Consulting: Political Solutions": "nbn",
  "P\u0101lan\u0101 Foods: Sustainable Growth": "jinteki",
  "Quetzal: Free Spirit": "anarch",
  "Reina Roja: Freedom Fighter": "anarch",
  'Ren\u00e9 "Loup" Arcemont: Party Animal': "anarch",
  'Rielle "Kit" Peddler: Transhuman': "shaper",
  'Ry\u014d "Phoenix" \u014cno: Out of the Ashes': "anarch",
  "SSO Industries: Fueling Innovation": "weyland_consortium",
  "SYNC: Everything, Everywhere": "nbn",
  "Saraswati Mnemonics: Endless Exploration": "jinteki",
  "Sebasti\u00e3o Souza Pessoa: Activist Organizer": "anarch",
  "Seidr Laboratories: Destiny Defined": "haas_bioroid",
  "Silhouette: Stealth Operative": "criminal",
  "Skorpios Defense Systems: Persuasive Power": "weyland_consortium",
  "Spark Agency: Worldswide Reach": "nbn",
  "Sportsmetal: Go Big or Go Home": "haas_bioroid",
  "Steve Cambridge: Master Grifter": "criminal",
  "Strategic Innovations: Future Forward": "haas_bioroid",
  "Sunny Lebeau: Security Specialist": "sunny_lebeau",
  "Synapse Global: Faster than Thought": "nbn",
  "Synthetic Systems: The World Re-imagined": "jinteki",
  "Tennin Institute: The Secrets Within": "jinteki",
  "The Catalyst: Convention Breaker": "neutral_runner",
  "The Collective: Williams, Wu, et al.": "UNKNOWN",
  "The Foundry: Refining the Process": "haas_bioroid",
  "The Masque: Cyber General": "neutral_runner",
  "The Outfit: Family Owned and Operated": "weyland_consortium",
  "The Professor: Keeper of Knowledge": "shaper",
  "The Shadow: Pulling the Strings": "neutral_corp",
  "The Syndicate: Profit over Principle": "neutral_corp",
  "The Zwicky Group: Invisible Hands": "weyland_consortium",
  "Thule Subsea: Safety Below": "haas_bioroid",
  "Thunderbolt Armaments: Peace Through Power": "haas_bioroid",
  "Titan Transnational: Investing In Your Future": "weyland_consortium",
  "Topan: Ormas Leader": "anarch",
  "T\u0101o Salonga: Telepresence Magician": "shaper",
  "Valencia Estevez: The Angel of Cayambe": "anarch",
  "Weyland Consortium: Because We Built It": "weyland_consortium",
  "Weyland Consortium: Builder of Nations": "weyland_consortium",
  "Weyland Consortium: Building a Better World": "weyland_consortium",
  "Weyland Consortium: Built to Last": "weyland_consortium",
  "Whizzard: Master Gamer": "anarch",
  "Wyvern: Chemically Enhanced": "anarch",
  "Zahya Sadeghi: Versatile Smuggler": "criminal",
});

export const FACTION_COLOURS: Record<string, string> = Object.freeze({
  UNKNOWN: "neutral",
  adam: "yellow",
  anarch: "orange",
  apex: "rose",
  criminal: "blue",
  haas_bioroid: "purple",
  jinteki: "red",
  nbn: "amber",
  neutral_corp: "slate",
  neutral_runner: "stone",
  shaper: "green",
  sunny_lebeau: "violet",
  weyland_consortium: "emerald",
});

export const KNOWN_RANGES: Record<string, KnownRangeSource[]> = Object.freeze({
  standard: [
    { label: "Core Set", start: "2012-01-01", end: "2017-09-30" },
    { label: "Revised Core Set", start: "2017-10-01", end: "2018-12-20" },
    { label: "System Core 2019", start: "2018-12-21", end: "2019-12-26" },
    { label: "Ashes", start: "2019-12-27", end: "2021-05-08" },
    { label: "20.06", start: "2020-06-26", end: "2020-09-24" },
    { label: "20.09", start: "2020-09-25", end: "2021-04-08" },
    { label: "System Gateway", start: "2021-04-09", end: "2022-08-04" },
    { label: "21.04", start: "2021-04-09", end: "2021-04-30" },
    { label: "21.05", start: "2021-05-01", end: "2021-06-18" },
    { label: "21.06", start: "2021-06-19", end: "2021-10-28" },
    { label: "21.10", start: "2021-10-29", end: "2022-08-04" },
    { label: "Borealis", start: "2022-08-05", end: "2023-08-10" },
    { label: "22.08", start: "2022-08-05", end: "2022-09-22" },
    { label: "22.09", start: "2022-09-23", end: "2023-03-02" },
    { label: "23.03", start: "2023-03-03", end: "2023-08-10" },
    { label: "Liberation", start: "2023-08-11", end: "2025-04-23" },
    { label: "23.08", start: "2023-08-11", end: "2023-09-21" },
    { label: "23.09", start: "2023-09-22", end: "2024-03-29" },
    { label: "24.03", start: "2024-03-30", end: "2024-05-30" },
    { label: "24.05", start: "2024-05-31", end: "2024-09-12" },
    { label: "24.09", start: "2024-09-13", end: "2024-12-25" },
    { label: "24.12", start: "2024-12-26", end: "2025-04-23" },
    { label: "Elevation", start: "2025-04-24", end: "2026-10-10" },
    { label: "25.04", start: "2025-04-24", end: "2025-07-31" },
    { label: "25.08", start: "2025-08-01", end: "2025-10-02" },
    { label: "25.10", start: "2025-10-03", end: "2025-11-30" },
    { label: "25.12", start: "2025-12-01", end: "2026-10-10" },
  ],
  startup: [
    { label: "Ashes", start: "2021-03-28", end: "2022-07-21" },
    { label: "Midnight Sun", start: "2022-07-22", end: "2022-12-08" },
    { label: "Borealis", start: "2022-12-09", end: "2023-07-30" },
    { label: "TAI", start: "2023-07-31", end: "2024-03-17" },
    { label: "24.01", start: "2024-01-19", end: "2024-03-17" },
    { label: "Liberation", start: "2024-03-18", end: "2025-04-23" },
    { label: "24.09", start: "2024-09-20", end: "2025-04-23" },
    { label: "Elevation", start: "2025-04-24", end: "2026-10-10" },
    { label: "25.04", start: "2025-04-24", end: "2025-11-02" },
    { label: "25.11", start: "2025-11-03", end: "2026-10-10" },
  ],
});
